// client/src/components/StudyGroup/studyGroupConfig.js

export const SUBJECT_SUGGESTIONS = [
  "Biology",
  "Anatomy",
  "Mathematics",
  "Computer Science",
  "Chemistry",
  "Nursing",
  "Physics",
  "Law & Ethics",
  "Business",
];

export const CAPACITY_PRESETS = [5, 10, 15, 25, 50];

export const COLOR_VARIANTS = {
  blue: {
    border: "border-blue-500",
    topAccent: "bg-blue-500",
    badgeBg: "bg-blue-50 text-blue-700 border-blue-100",
    iconBg: "bg-blue-100 text-blue-600",
    btn: "bg-blue-50 text-blue-600 hover:bg-blue-100",
    progress: "bg-blue-500",
    glow: "group-hover:shadow-blue-500/10",
    dot: "bg-blue-50",
    pickerBg: "bg-[#3B82F6]",
  },
  purple: {
    border: "border-purple-500",
    topAccent: "bg-purple-500",
    badgeBg: "bg-purple-50 text-purple-700 border-purple-100",
    iconBg: "bg-purple-100 text-purple-600",
    btn: "bg-purple-50 text-purple-600 hover:bg-purple-100",
    progress: "bg-purple-500",
    glow: "group-hover:shadow-purple-500/10",
    dot: "bg-purple-50",
    pickerBg: "bg-[#A855F7]",
  },
  green: {
    border: "border-emerald-500",
    topAccent: "bg-emerald-500",
    badgeBg: "bg-emerald-50 text-emerald-700 border-emerald-100",
    iconBg: "bg-emerald-100 text-emerald-600",
    btn: "bg-emerald-50 text-emerald-600 hover:bg-emerald-100",
    progress: "bg-emerald-500",
    glow: "group-hover:shadow-emerald-500/10",
    dot: "bg-emerald-50",
    pickerBg: "bg-[#10B981]",
  },
  orange: {
    border: "border-orange-500",
    topAccent: "bg-orange-500",
    badgeBg: "bg-orange-50 text-orange-700 border-orange-100",
    iconBg: "bg-orange-100 text-orange-600",
    btn: "bg-orange-50 text-orange-600 hover:bg-orange-100",
    progress: "bg-orange-500",
    glow: "group-hover:shadow-orange-500/10",
    dot: "bg-orange-50",
    pickerBg: "bg-[#F97316]",
  },
};

export const getTheme = (color) => COLOR_VARIANTS[color] || COLOR_VARIANTS.blue;
